<route>
{
  "meta": {
    "permission": [
      "contenttypes.view_contenttype"
    ]
  }
}
</route>

<template>
  <v-card class="px-2 my-3">
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submit)">
        <i-toolbar
          :title="
            role.pk != undefined && role.pk != ''
              ? `${$t('edit')} ${$tc('role_permissions', 1)}`
              : `${$t('add', { value: $tc('role_permissions', 1) })}`
          "
          :loading="load"
        ></i-toolbar>
        <v-card-text>
          <v-row class="my-0">
            <v-col v-for="area in areas" :key="area.pk" cols="12" md="6" lg="4">
              <h5 class="text-capitalize mb-0">{{ area.name }}</h5>
              <v-switch
                v-for="permission in area.areapermissions"
                :key="permission.pk"
                :label="permission.name"
                :input-value="Boolean(selectedPermissions[permission.pk])"
                @change="setPermission(permission.pk, $event)"
                class="v-switch mt-0"
                hide-details
              >
              </v-switch>
              <hr />
            </v-col>
          </v-row>
        </v-card-text>
      </form>
    </ValidationObserver>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      load: false,
      loading: false,
      areas: [],
      selectedPermissions: {},
      role: {
        pk: '',
        name: '',
        permisions: []
      }
    }
  },
  methods: {
    getGroups() {
      this.loading = true
      let validation = this.codification({
        mode: 'decode',
        code: this.$route.params.pk
      })
      if (validation == 'create') {
        if (this.$store.getters['utils/getIsloading']) {
          this.$store.dispatch('utils/actionLoading')
          this.$route.meta.title = this.$t('create', { model: '' })
        }
        this.role = {
          pk: '',
          name: '',
          permisions: []
        }
        this.selectedPermissions = {}
      } else {
        this.$api.role.show({ pk: validation }).then((res) => {
          this.role = res.data
          this.selectedPermissions = this.role.permissions.reduce(
            (selected, permission) => {
              selected[permission.pk] = true
              return selected
            },
            {}
          )
          this.$route.meta.title = this.$t('edit', { model: '' })
        })
      }
    },
    async submit() {
      var dato = {
        group_id: this.role.pk,
        permissions: Object.keys(this.selectedPermissions)
          .filter((permissionPk) => this.selectedPermissions[permissionPk])
          .map((permissionPk) => ({ pk: Number(permissionPk) }))
      }
      try {
        this.load = true
        this.role.pk === ''
        await this.$api.role.permission.edit({
          pk: this.role.pk,
          form: dato
        })
        this.getGroups()
        this.$toast.success(`${this.$tc('roles', 1)} ${this.$tc('edited', 2)}`)
        this.$router.push({ name: 'roles' })
      } finally {
        this.load = false
      }
    },
    setPermission(permissionPk, selected) {
      this.$set(this.selectedPermissions, permissionPk, selected)
    },
    getRoleAreas() {
      this.$api.role.areas
        .list({})
        .then((response) => {
          this.areas = response.data
        })
        .finally(() => {
          if (this.$store.getters.getIsloading) {
            this.$store.dispatch('actionLoading')
          }
          this.loading = false
        })
    }
  },
  mounted() {
    this.getGroups()
    this.getRoleAreas()
  }
}
</script>
